
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.92 37.25c-1.24 1.22-2.51 2.46-3.74 3.67l1.73 1.73 4.56-4.56v-7.57h-2.55v6.73z","fill":"none"}}),_c('path',{attrs:{"d":"M47.49 31.01c-.24-.31-.35-.6-.35-.99.01-7.52.01-15.03.01-22.55 0-2.08-1.47-3.56-3.56-3.56-12.46 0-24.93-.01-37.39 0-2.08 0-3.54 1.49-3.54 3.57V43h27.37c.11.17.19.3.27.42 2.53 3.63 6.02 5.34 10.41 4.74 4.03-.55 6.91-2.84 8.4-6.63 1.46-3.75.87-7.31-1.62-10.52zm-7.01 7.08l-4.56 4.56c-.55-.55-1.13-1.14-1.73-1.73 1.23-1.2 2.5-2.45 3.74-3.67v-6.73h2.55v7.57zm4.07-22.13H33.61v6.17h10.93v3H33.61v3.28c-1.17.71-2.18 1.63-3 2.72-.04.06-.09.12-.13.17-.65.91-1.18 1.91-1.52 3h-9.22v6.1h-3v-6.1H5.26v-3h11.48v-6.17H5.26v-3h11.48v-6.17H5.26v-3h11.48V6.51h3v6.45h10.87V6.51h3v6.45h10.93v3z"}}),_c('path',{attrs:{"d":"M19.74 25.13v6.17h10.74c.04-.06.09-.12.13-.17v-6H19.74zM19.74 15.96h10.87v6.17H19.74z"}})])
          )
        }
      }
    